import { render, staticRenderFns } from "./FollowupMessageDrawer.vue?vue&type=template&id=6f5ee062&scoped=true&"
import script from "./FollowupMessageDrawer.vue?vue&type=script&lang=js&"
export * from "./FollowupMessageDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FollowupMessageDrawer.vue?vue&type=style&index=0&id=6f5ee062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ee062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider,VExpansionPanel,VExpansionPanelContent,VIcon,VLayout,VNavigationDrawer,VSpacer,VTextarea,VToolbar,VToolbarTitle})
